import { getScores } from './score';
import { sanitizeHtml } from '../../../utils/sanitize';

const formatField = (fieldDefinition, fieldData) => {
  if (fieldDefinition.inputType === 'toggle') {
    return fieldData ? true : false;
  }
  if (typeof fieldData === 'string' && fieldData) {
    return sanitizeHtml(fieldData) || '';
  }
  return fieldData;
};

export const getSections = (profile, scheme) => {
  if (!scheme || !scheme.sections) {
    return [];
  }
  return scheme.sections
    .filter((section) => section && section.visible === true)
    .map((section) => {
      const scores = getScores(section.ratings, scheme);
      return {
        key: section.key,
        label: section.label,
        color: section.color,
        icon: section.icon,
        scores,
        canPrint: section.features?.sectionPrint?.enabled,
        fields: (section.fields || [])
          .filter((field) => field && field.visible === true)
          .map((field) => ({
            name: field.label,
            value: formatField(field, profile.data?.[field.key]),
            preview: !!(field.preview && profile.data?.[field.key]),
          }))
          .filter((field) => field.value !== null && field.value !== undefined),
      };
    });
};
